import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../environments/environment";

export interface FinalReportTestDataRequestDto {
    projectId: number; 
    projectTypeId: number; 
    slurryId: number; 
    includeUnapproved: boolean;
}


@Injectable({ providedIn: 'root' })
export class FinalReportService {

    constructor(private http: HttpClient) {
    }
    private readonly baseUrl = environment.apiUrl;
    
    getFinalReportTestData(request: FinalReportTestDataRequestDto): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/project-details/test-data`, request);
    }

    generateFinalReport(projectId: number, payload: any): Observable<Blob> {
        return this.http.post(
                `${this.baseUrl}/project-details/${projectId}/generate`,
                payload,
                { responseType: 'blob' }
        );
    }
}